import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { BaoCaoKiemKe } from "../models/taisan/TaiSan";
import { BienBanKiemKe, LuuBienBanKiemKeRequest } from "../models/taisan/BienBanKiemKe";
import intance from "../utils/axios";

export const layDsBienBanKiemKe = async (idDotKiemKe: number, idDonVi?: number) => {
    var rs: BienBanKiemKe[] = [];
    let url = ApiPaths.bienBanKiemKe.layDs + "?idDotKiemKe=" + idDotKiemKe;
    if (idDonVi) url += "&idDonVi=" + idDonVi;
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu || [];
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const layChiTietBienBanKiemKe = async (id: number) => {
    var rs: BienBanKiemKe | null = null;
    await intance.get(ApiPaths.bienBanKiemKe.layChiTiet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const layBangTongHopKiemKe = async (idDotKiemKe: number, idDonVi?: number, idDotKiemKeTruoc?: number) => {
    var rs: BaoCaoKiemKe[] = [];
    let url = ApiPaths.bienBanKiemKe.layBangTongHop + "?idDotKiemKe=" + idDotKiemKe;
    if (idDonVi) url += "&idDonVi=" + idDonVi;
    if (idDotKiemKeTruoc) url += "&idDotKiemKeTruoc=" + idDotKiemKeTruoc;
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu || [];
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const luuBienBanKiemKe = async (request: LuuBienBanKiemKeRequest) => {
    var rs: number = 0;
    await intance.post(ApiPaths.bienBanKiemKe.luu, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const xoaBienBanKiemKe = async (id: number) => {
    await intance.post(ApiPaths.bienBanKiemKe.xoa + "?id=" + id, {})
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xuatExcelBienBanKiemKePhongBan = async (idDotKiemKe?: number, idDonVi?: number, idBienBan?: number) => {
    let url = ApiPaths.bienBanKiemKe.xuatExcelPhongBan + "?";
    if (idBienBan) url += `idBienBan=${idBienBan}&`;
    if (idDotKiemKe) url += `idDotKiemKe=${idDotKiemKe}&`;
    if (idDonVi) url += `idDonVi=${idDonVi}&`;
    const response = await intance.get(url, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `BienBanKiemKe_${idBienBan ? `BB${idBienBan}_` : ''}DonVi_${idDotKiemKe || ''}_${idDonVi || 'all'}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(link.href);
};

